import { IconFunctionalSuccessCircle16, Select, UIText2 } from '@cian/ui-kit';
import * as React from 'react';

import { ESavedSearchFrequency } from '../../../../types/savedSearch';

import styles from './styles.css';

interface IStatusProps {
  status?: string;
  frequency?: string | null;
  selectedFrequency?: string | null;
  isEmailConfirmed: boolean;
  onChange: (value: ESavedSearchFrequency) => void;
}

const NOTIFICATION_FREQUENCY_OPTIONS = [
  { value: ESavedSearchFrequency.None, label: 'Не получать оповещения' },
  { value: ESavedSearchFrequency.Asap, label: 'Мгновенно' },
  { value: ESavedSearchFrequency.Hourly, label: 'Раз в час' },
  { value: ESavedSearchFrequency.Daily, label: 'Раз в день' },
];

export const Status: React.FC<IStatusProps> = ({
  status,
  frequency,
  selectedFrequency,
  isEmailConfirmed,
  onChange,
}) => (
  <>
    {status === 'inactive' && !isEmailConfirmed ? (
      <div className={styles['activation-hint']}>
        <IconFunctionalSuccessCircle16 color="text-positive-default" />
        <UIText2>Ссылка для активации подписки отправлена на почту</UIText2>
      </div>
    ) : (
      <div className={styles['container']} data-name="frequency-select" onClick={e => e.stopPropagation()}>
        <Select
          width={250}
          options={NOTIFICATION_FREQUENCY_OPTIONS}
          size="XS"
          value={frequency || selectedFrequency || ESavedSearchFrequency.None}
          onChange={onChange}
        />
      </div>
    )}
  </>
);
